import { RewardsAdminRoleType } from "@rewards-web/shared/graphql-types";

export const adminRolesMap = {
  [RewardsAdminRoleType.ProgramManager]: "Program Manager",
  [RewardsAdminRoleType.Executive]: "Executive",
  [RewardsAdminRoleType.Coordinator]: "Coordinator",
  [RewardsAdminRoleType.Finance]: "Finance",
  [RewardsAdminRoleType.HumanResources]: "Human Resources",
};
